import React from 'react';
import LocalizedStrings from 'react-localization';
import store from '../../store';

const strings = new LocalizedStrings({
	'en': require('./i18n/en.json'),
	'id': require('./i18n/id.json'),
	'th': require('./i18n/th.json'),
	'vi': require('./i18n/vi.json'),
	'ms': require('./i18n/ms.json'),
	'zh-tw': require('./i18n/zh-Hant.json')
});

export const trans = (key, params) => {
	const state = store.getState();
	let lang = state.data.language.lang.toLowerCase();

	if (strings.getAvailableLanguages().indexOf(lang) > -1) {
		strings.setLanguage(lang);
	} else {
		console.warn('lang not available: ' + lang + ' ,available languages: ' + JSON.stringify(strings.getAvailableLanguages()));
	}

	let string = '';
	if (strings.hasOwnProperty(key)) {
		string = strings[key];
		// @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
		if (params && Object.prototype.toString.call(params) === '[object Array]') {
			params.unshift(string);
			string = strings.formatString.apply(strings, params);
		} else if (params && Object.prototype.toString.call(params) === '[object Object]') {
			string = strings.formatString(string, params);
		}
		if (string.indexOf('\n') > -1) {
			let lines = string.split('\n');
			return (
				<span key={key}>
					{lines.map((text, index) => {
						if (index + 1 === lines.length) {
							return text;
						} else {
							return <span key={index}>{text}<br /></span>;
						}
					})}
				</span>
			);
		}
	}
	return string;
};



// WEBPACK FOOTER //
// ./app/localization/language.js